import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'textRenderHtml'})
export class TextRenderHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value).replace(/\n/g, '<br/>');
  }
}
